import { gql } from '@apollo/client';
import eventFragment from './eventFragment';
import eventAssignmentsFragment from './eventAssignmentsFragment';

const EDIT_EVENT = gql`
  mutation EditEvent($event: EditEventInput!) {
    editEvent(event: $event) {
      ...EventFields
      EventAssignments {
        ...EventAssignmentsFields
      }
    }
  }

  ${eventFragment}
  ${eventAssignmentsFragment}
`;

export default EDIT_EVENT;
